export default __webpack_public_path__ + "static/media/shopping-cart.b9ce9e14.svg";